import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowDown_xl = (props) => {
    const width = props.width ? props.width + 'px' : '40px';
    const height = props.height ? props.height + 'px' : '40px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33.7071 21.2929C34.0976 21.6834 34.0976 22.3166 33.7071 22.7071L20.7071 35.7071C20.5196 35.8946 20.2652 36 20 36C19.7348 36 19.4804 35.8946 19.2929 35.7071L6.29289 22.7071C5.90237 22.3166 5.90237 21.6834 6.29289 21.2929C6.68342 20.9024 7.31658 20.9024 7.70711 21.2929L19 32.5858L19 5C19 4.44771 19.4477 4 20 4C20.5523 4 21 4.44771 21 5L21 32.5858L32.2929 21.2929C32.6834 20.9024 33.3166 20.9024 33.7071 21.2929Z"
            />
        </SvgStyled>
    );
};

export default ArrowDown_xl;
